/**
 * Converts a bigint to a JSON-compatible string.
 * @function toJSON
 * @param {bigint} num - The bigint to convert.
 * @returns {string} The JSON-compatible string representation of the bigint.
 */
const toJSON = (num: bigint): string => {
  return num?.toString() || '';
};

export { toJSON };
